export default "__VITE_PUBLIC_ASSET__fe8c5f89__"